import Layout from '../Layout/Layout';
import Loader from '../Layout/Loader';

const AchievementsPlaceholder = () => (
  <Layout page="diet-settings">
    <div className="full-height">
      <Loader />
    </div>
  </Layout>
);

export default AchievementsPlaceholder;
